import { camelToTitle } from 'utils';

const mapEdrsEnabled = (value) => {
    if (value === true) return 'yes';
    if (value === false) return 'no';
    return null;
};
export function isChinaRegionRequired(order) {
    return (
        order?.onboardingCategory &&
        (order?.onboardingCategory === 'New Solution' || order?.onboardingCategory === 'Modify Existing Solution') &&
        ((order?.cloudType && order?.cloudType === 'AZURE') || (order?.typeOfCloud && order?.typeOfCloud.toUpperCase() === 'AZURE'))
    );
}

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const hasContributorOwner = catalogConfig?.createContributorAdGroup !== undefined;
    const hasReaderOwner = catalogConfig?.createReaderAdGroup !== undefined;
    const hasContributorGroups = Boolean(catalogConfig?.contributorAdGroups?.length);
    const hasReaderGroups = Boolean(catalogConfig?.readerAdGroups?.length);
    // Set privilegedADGroup value based on conditions
    let privilegedADGroup = null;
    if (hasContributorGroups) {
        privilegedADGroup = 'Yes';
    } else if (hasContributorOwner) {
        privilegedADGroup = catalogConfig?.createContributorAdGroup ? 'No' : '';
    } else if (catalogConfig?.activeDirectoryGroupOwnerId) {
        privilegedADGroup = 'No';
    }

    // Set nonPrivilegedADGroup value based on conditions
    let nonPrivilegedADGroup = null;
    if (hasReaderGroups) {
        nonPrivilegedADGroup = 'Yes';
    } else if (hasReaderOwner) {
        nonPrivilegedADGroup = catalogConfig?.createReaderAdGroup ? 'No' : '';
    }

    // Compute requirePrivilegedADGroup: only for custom/network and when owner/groups present
    const isCustomOrNetwork = catalogConfig?.accountType === 'custom' || catalogConfig?.accountType === 'network';
    const hasOwnerOrGroups = hasContributorGroups || hasContributorOwner || Boolean(catalogConfig?.activeDirectoryGroupOwnerId);
    const mappedRequirePrivilegedADGroup = isCustomOrNetwork && hasOwnerOrGroups ? 'yes' : 'no';

    // Map awsAccountName and sharedNetworkAcct based on accountType/hasDepartment
    let mappedAwsAccountName = null;
    let mappedSharedNetworkAcct = null;
    if (catalogConfig?.accountType === 'application') {
        mappedAwsAccountName = catalogConfig?.awsAccountName || null;
    } else if (catalogConfig?.accountType === 'network' || catalogConfig?.accountType === 'custom') {
        if (catalogConfig?.hasDepartment === true || catalogConfig?.isIsolatedAccount === true) {
            mappedAwsAccountName = catalogConfig?.awsAccountName || null;
        } else if (catalogConfig?.hasDepartment === false) {
            mappedSharedNetworkAcct = catalogConfig?.sharedNetworkAccountName || null;
        }
    }

    let mappedAccountType = null;
    if (catalogConfig?.accountType === 'application') {
        mappedAccountType = 'no';
    } else if (catalogConfig?.accountType === 'network' || catalogConfig?.accountType === 'custom') {
        mappedAccountType = 'yes';
    }

    return {
        ...(data?.id && { id: data?.id }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: catalogConfig?.budgetCode,
            sector: catalogConfig?.sector,
        },
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,

        // Application Section
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessApp: catalogConfig?.businessApplication || null,
        appProfile: catalogConfig?.applicationService || null,
        ...(catalogConfig?.applicationService && { appProfileDetails: { label: catalogConfig?.applicationService, value: catalogConfig?.applicationService } }),
        ...(!catalogConfig?.applicationService && { appProfileDetails: null }),
        region: catalogConfig?.region || null,
        regionDisplayname: catalogConfig?.region,
        sector: catalogConfig?.sector || 'CGF',
        hasIsolatedAccount: catalogConfig?.isIsolatedAccount ? 'yes' : 'no',
        businessSponsor: catalogConfig?.businessSponsor?.name || null,
        businessSponsorDetails: null,
        environments: catalogConfig?.environment || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.applicationShortName || null,
        accountType: mappedAccountType,
        awsAccountName: mappedAwsAccountName,
        sharedNetworkAcct: mappedSharedNetworkAcct,
        vpcName: catalogConfig?.vpcName || null,
        vpcId: catalogConfig?.vpcId || null,
        hasApplicationService: catalogConfig?.hasApplicationService ? 'yes' : 'no',
        hasDepartment: catalogConfig?.hasDepartment ? 'yes' : 'no',
        requirePrivilegedADGroup: mappedRequirePrivilegedADGroup,
        department: catalogConfig?.department || null,
        awsOrgUnit: catalogConfig?.ouName || null,
        awsOrgUnitDetails: {
            ouId: catalogConfig?.ouId || null,
        },
        appRegion: catalogConfig?.applicationRegion || null,
        awsSector: catalogConfig?.sector || null,
        awsEnvironment: catalogConfig?.environment[0] || null,
        awsRegion: catalogConfig?.region || null,
        businessCategory: catalogConfig?.businessCategory || null,
        hCode: catalogConfig?.costCenter || null,
        onPremHCode: catalogConfig?.onPremCostCenter || null,
        onPremHCodeDetails: { label: catalogConfig?.onPremCostCenter, value: catalogConfig?.onPremCostCenter } || null,
        additionalInfo: catalogConfig?.additionalInformation || null,
        dataClassification: catalogConfig?.dataClassification,
        awsCloudOnboardingOrderId: catalogConfig?.awsAccountOnboardOrderId || null,
        ...(catalogConfig?.edrsEnabled !== undefined && { isEDRSEnabled: mapEdrsEnabled(catalogConfig?.edrsEnabled) }),

        // Resource Section
        cloudType: catalogConfig?.typeOfCloud?.toUpperCase() || null,
        onboardingCategory: catalogConfig?.onboardingCategory || null,
        isaNumber: catalogConfig?.isaNumber || null,
        // csaApprovedArch: catalogConfig?.isCsaApproved ? 'yes' : 'no',
        ...(isChinaRegionRequired(catalogConfig) && { isChinaRegion: catalogConfig?.isChinaOnboarding ? 'yes' : 'no' }),
        ...(catalogConfig?.tacRequest && {
            tacRequest: catalogConfig?.tacRequest || null,
        }),
        // csa: catalogConfig?.csaApproval?.id || null,
        // csaDetails: null,
        prevCloudOnboardReq: catalogConfig?.previousCloudOnboardingRequest || null,
        adGroup: catalogConfig?.adGroup?.name || null,
        questionnaire: catalogConfig?.questionnaireResponses || {},
        // Only include AD group values if they are not null
        ...(privilegedADGroup !== null && { privilegedADGroup }),
        ...(nonPrivilegedADGroup !== null && { nonPrivilegedADGroup }),
        ...(privilegedADGroup === 'Yes' && {
            privilegedADGroupList: catalogConfig?.contributorAdGroups.map((app) => ({
                contributorValue: app?.name,
                contributorInputValue: app?.name,
            })),
        }),
        ...(nonPrivilegedADGroup === 'Yes' && {
            nonPrivilegedADGroupList: catalogConfig?.readerAdGroups.map((app) => ({
                readerValue: app?.name,
            })),
        }),
        ...(nonPrivilegedADGroup === 'No' && {
            nonPrivilegedADGroupOwner: catalogConfig?.activeDirectoryGroupOwnerId,
            nonPrivilegedADGroupOwnerDetails: null,
            applicationName: catalogConfig?.applicationName || null,
            appShortName: catalogConfig?.applicationShortName || null,
        }),
        ...(privilegedADGroup === 'No' && {
            privilegedADGroupOwner: catalogConfig?.activeDirectoryGroupOwnerId,
            privilegedADGroupOwnerDetails: null,
            applicationName1: catalogConfig?.applicationName || null,
            appShortName1: catalogConfig?.applicationShortName || null,
        }),
        ...(catalogConfig?.activeDirectoryGroupOwnerId && {
            privilegedADGroupOwner: catalogConfig?.activeDirectoryGroupOwnerId,
            privilegedADGroupOwnerDetails: null,
        }),
        isaValidationDetails: null,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromPrevOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const hasContributorOwner = catalogConfig?.createContributorAdGroup !== undefined;
    const hasContributorGroups = Boolean(catalogConfig?.contributorAdGroups?.length);
    // Set privilegedADGroup value based on conditions
    let privilegedADGroup = null;
    if (hasContributorGroups) {
        privilegedADGroup = 'Yes';
    } else if (hasContributorOwner) {
        privilegedADGroup = catalogConfig?.createContributorAdGroup ? 'No' : '';
    } else if (catalogConfig?.activeDirectoryGroupOwnerId) {
        privilegedADGroup = 'No';
    }

    return {
        // Application Section
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessApp: catalogConfig?.businessApplication || null,
        appProfile: catalogConfig?.applicationService || null,
        ...(catalogConfig?.applicationService && { appProfileDetails: { label: catalogConfig?.applicationService, value: catalogConfig?.applicationService } }),
        ...(!catalogConfig?.applicationService && { appProfileDetails: null }),
        businessSponsor: catalogConfig?.businessSponsor?.name || null,
        businessSponsorDetails: null,
        applicationName: catalogConfig?.applicationName || null,
        // appShortName: catalogConfig?.applicationShortName || null,
        hCode: catalogConfig?.costCenter || null,
        onPremHCode: catalogConfig?.onPremCostCenter || null,
        onPremHCodeDetails: { label: catalogConfig?.onPremCostCenter, value: catalogConfig?.onPremCostCenter } || null,
        additionalInfo: catalogConfig?.additionalInformation || null,
        dataClassification: catalogConfig?.dataClassification,
        businessCategory: catalogConfig?.businessCategory || null,
        ...(catalogConfig?.edrsEnabled !== undefined && { isEDRSEnabled: mapEdrsEnabled(catalogConfig?.edrsEnabled) }),
        adGroup: catalogConfig?.adGroup?.name || null,
        // Only include AD group values if they are not null
        ...(privilegedADGroup !== null && { privilegedADGroup }),
        ...(privilegedADGroup === 'Yes' && {
            privilegedADGroupList: catalogConfig?.contributorAdGroups.map((app) => ({
                contributorValue: app?.name,
            })),
        }),
        ...(privilegedADGroup === 'No' && {
            privilegedADGroupOwner: catalogConfig?.activeDirectoryGroupOwnerId,
            privilegedADGroupOwnerDetails: null,
        }),
        ...(catalogConfig?.activeDirectoryGroupOwnerId && {
            privilegedADGroupOwner: catalogConfig?.activeDirectoryGroupOwnerId,
            privilegedADGroupOwnerDetails: null,
        }),
        isaValidationDetails: null,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formUploadObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;

    return (
        catalogConfig?.attachments?.map((item) => ({
            id: item?.id,
            name: item?.fileName,
            blobRelativeLink: item?.blobRelativeLink,
            size: item?.fileSize || 0,
        })) || []
    );
};

export const resetOrder = {
    entityDetails: null,
    billingEntity: null,
    appProfile: null,
    appProfileDetails: null,
    appName: null,
    applicationName: null,
    appShortName: null,
    appOwner: null,
    appOwnerDetails: null,
    applicationName1: null,
    appShortName1: null,
    sector: 'CGF',
    department: null,
    appRegion: null,
    landingZoneDetails: null,
    vpcName: null,
    vpcId: null,
    region: 'us-east-1',
    environments: [],
    awsEnvironment: null,
    awsAccountName: null,
    awsOrgUnit: null,
    awsOrgUnitDetails: null,
    businessCategory: null,
    hCode: null,
    onPremHCode: null,
    onPremHCodeDetails: null,
    additionalInfo: null,
    businessAppDetails: null,
    businessApp: null,
    businessSponsor: null,
    businessSponsorDetails: null,
    dataClassification: null,
    awsCloudOnboardingOrderId: null,

    // Resource Setion
    cloudType: null,
    isaNumber: null,
    onboardingCategory: null,
    // csaApprovedArch: 'no',
    tacRequest: null,
    prevCloudOnboardReq: null,
    csa: null,
    csaDetails: null,
    nonPrivilegedADGroupList: [{ readerValue: '' }],
    privilegedADGroupList: [{ contributorValue: '' }],
    privilegedADGroup: null,
    nonPrivilegedADGroup: null,
    privilegedADGroupOwner: null,
    privilegedADGroupOwnerDetails: null,
    nonPrivilegedADGroupOwner: null,
    nonPrivilegedADGroupOwnerDetails: null,

    // New fields for enhanced form
    accountType: null, // 'custom' or 'network'
    hasApplicationService: null, // 'yes' or 'no'
    hasDepartment: null, // 'yes' or 'no'
    hasIsolatedAccount: null, // 'yes' or 'no'
    requirePrivilegedADGroup: null, // 'yes' or 'no' - not mandatory
    sharedNetworkAcct: null, // Shared Network Account Name
    tags: {}, // Tags section data

    isEDRSEnabled: null,
    deletedFiles: [],
    isChinaRegion: 'no',
    adGroup: null,
    questionnaire: {},
    estimatedCost: null,
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetCostEstimateDetails = {
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: 0,
        currency: 'USD',
    },
    totalOneTimeCost: {
        frequency: 'One Time',
        estCost: 0,
        currency: 'USD',
    },

    notes: 'There is no cost for this Cloud onboarding request, however there will be cost involved based on the service Name defined at the Resource Group level for your resources that being provisioned in future.',
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isNonPrivilegedADGroupOpen: false,
    isPrivilegedADGroupOpen: false,
    isADGroupModalOpen: false,
};
export const isUniqueOwner = (value = null, selectedvalues = []) => {
    return selectedvalues.indexOf(value) === -1;
};
export const getValueFromKey = (searchKey, keyValuePairs) => {
    return keyValuePairs[searchKey] ? keyValuePairs[searchKey] : camelToTitle(searchKey);
};
export const mappingLabel = {
    isaNumber: 'ISA Number',
    isaStatus: 'ISA Status',
    parentIsaNumber: 'Parent ISA Number',
    parentIsaNumberStatus: 'Parent ISA Number Status',
    scanNumber: 'SCAN Number',
    scanStatus: 'SCAN Status',
    scanTaskNumber: 'SCAN Task Number',
    scanTaskState: 'SCAN Task State',
};

export const isDuplicate = (adGroupArray, adGroup) => {
    const duplicateReaderADGroups = adGroupArray?.filter((item, index) => adGroupArray.indexOf(item) !== index);
    if (adGroup) {
        return duplicateReaderADGroups.indexOf(adGroup) > -1;
    }
    return false;
};

export const isADGroupError = (validationMessage = [], adGroup = null) => {
    let errorCount = 0;
    let adGroupError = false;
    if (Array.isArray(validationMessage)) {
        validationMessage?.forEach((item) => {
            if (item.includes(adGroup)) {
                // eslint-disable-next-line no-plusplus
                errorCount++;
            }
        });
    }
    adGroupError = errorCount !== 0;
    return adGroupError;
};

export const isADGroupFormValid = (order) => {
    let errorCount = 0;
    let isValid = false;
    if (order?.adGroupList?.length) {
        order?.adGroupList?.forEach((item) => {
            if (item && (item?.adGroupValue === '' || item?.adGroupValue === null)) {
                errorCount += 1;
            }
        });
    }
    isValid = errorCount === 0;
    return isValid;
};

export const isADGroupDuplicate = (order) => {
    const adGroupArray = order?.adGroupList?.map((item) => item?.adGroupValue);
    return new Set(adGroupArray).size !== adGroupArray.length;
};

export { formatAwsAccountVendingPreview } from './previewFormatter';
